import React from 'react';
import {
  Routes, Route, useLocation, matchPath,
} from 'react-router-dom';

import PageNotFound from '@zimpel/common/components/PageNotFound';
import OptOutToken from './components/OptOutToken';
import OptOutTestmail from './components/OptOutTestmail';

export const OPT_OUT_PATH = '/opt_out/*';

export const useIsOptOutPath = () => {
  const { pathname } = useLocation();
  return matchPath(OPT_OUT_PATH, pathname);
};

const Router: React.FC = () => (
  <Routes>
    <Route path=":language/testmail" element={<OptOutTestmail />} />
    <Route path=":language/:token" element={<OptOutToken />} />
    <Route path="*" element={<PageNotFound />} />
  </Routes>
);

export default Router;
